import {createApi} from '@reduxjs/toolkit/query/react';
import {axiosBaseQuery, REFETCH_POLICY} from 'src/axiosBaseQuery';
import {DefaultResponse} from 'src/types';
import {
    PageReOwnersDTO,
    ReOwnerCreationRequest,
    ReOwnerDeleteRequest,
    ReOwnerDTO,
    ReOwnerGetRealEstateRequest,
    ReOwnerGetReOwnersRequest,
    ReOwnerUpdateRequest,
} from 'src/types/reOwner';
import {getBaseURL} from 'src/utils/helper';

export const reOwnerApi = createApi({
    reducerPath: 'reOwnerApi',
    ...REFETCH_POLICY,
    baseQuery: axiosBaseQuery({
        baseUrl: String(getBaseURL() + '/realEstates'),
    }),
    tagTypes: ['ReOwner'],
    endpoints: (build) => {
        return {
            getRealEstate: build.query<ReOwnerDTO, ReOwnerGetRealEstateRequest>({
                query: (data) => ({
                    url: `/${data.realEstateId}?businessId=${data.businessId}`,
                    method: 'get',
                }),
            }),
            createNewReOwner: build.mutation<DefaultResponse, ReOwnerCreationRequest>({
                query: (data) => ({url: '', method: 'post', data}),
                invalidatesTags: ['ReOwner'],
            }),
            updateReOwner: build.mutation<ReOwnerDTO, ReOwnerUpdateRequest>({
                query: ({realEstateId, data}) => ({
                    url: `/${realEstateId}`,
                    method: 'put',
                    data,
                }),
                invalidatesTags: ['ReOwner'],
            }),
            deleteReOwner: build.mutation<DefaultResponse, ReOwnerDeleteRequest>({
                query: ({realEstateId, businessId}) => ({
                    url: `/${realEstateId}?businessId=${businessId}`,
                    method: 'delete',
                }),
                invalidatesTags: ['ReOwner'],
            }),
            getReOwners: build.query<PageReOwnersDTO, ReOwnerGetReOwnersRequest>({
                query: ({data, params}) => ({
                    url: '/search',
                    method: 'post',
                    data: {
                        businessId: data.businessId,
                    },
                    params,
                }),
                providesTags: ['ReOwner'],
            }),
        };
    },
});
